import { Injectable } from '@angular/core';
import { FeatureCollection, Geometry } from 'geojson';
import * as mapboxgl from 'mapbox-gl';
import { take } from 'rxjs/operators';
import { MapService } from 'src/app/shared/components/map/map.service';
import { ResultMapService } from './result-map.service';

@Injectable({
  providedIn: 'root'
})
export class ResultMapSquareLayerService {

  private static readonly SOURCE_NAME = 'mitra-result-square';

  constructor(
    private resultMapService: ResultMapService,
    private mapService: MapService,
  ) { }

  load(projectId: number, simulationId: any) {
    this.resultMapService.getSquares(projectId, simulationId)
      .pipe(take(1))
      .subscribe(collection => {
        this.populateMap(collection);
      });
  }

  clean() {
    this.mapService.map$.subscribe(m => {
      const source = this.getSource(m);
      if (source) {
        source.setData({
          type: 'FeatureCollection',
          features: []
        });
      }
    });
  }

  private populateMap(collection: FeatureCollection<Geometry, { [name: string]: any; }>) {
    this.mapService.map$.subscribe(m => {
      this.createDataSource(m, collection);
      this.createLayer(m);
    });
  }

  private createDataSource(mapbox: mapboxgl.Map, collection: FeatureCollection<Geometry, { [name: string]: any; }>) {
    const source = this.getSource(mapbox);
    if (source) {
      source.setData(collection);
      return;
    }

    mapbox.addSource(
      ResultMapSquareLayerService.SOURCE_NAME,
      {
        type: 'geojson',
        data: collection
      });
  }

  private getSource(mapbox: mapboxgl.Map) {
    return mapbox.getSource(ResultMapSquareLayerService.SOURCE_NAME) as mapboxgl.GeoJSONSource;
  }

  private createLayer(mapbox: mapboxgl.Map) {
    if (mapbox.getLayer(ResultMapSquareLayerService.SOURCE_NAME)) {
      return;
    }
    mapbox.addLayer({
      id: ResultMapSquareLayerService.SOURCE_NAME,
      type: 'line',
      source: ResultMapSquareLayerService.SOURCE_NAME,
      layout: { visibility: 'visible' },
      paint: {
        'line-color': '#e55e5e',
        'line-width': 0.5
      }
    });
  }

}
